import React from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import Searcher from "~styled/searcher/searcher";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import Pagination from "~styled/pagination/Pagination";
import { type OptionKV } from "~styled/selector/Selector";
import { paginationOptions } from "~constants/pagination";
import {
  setPage,
  setTake,
  selectSearchCriteria,
  setGetOnlyActivos,
} from "./actions";
import { permissionHandleUserActivo } from "~constants/usuarios";
import { TakeValue } from "../types";

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingBottom: 20,
    width: "100%",
  },
  filters: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  label: {
    fontSize: "10px",
    fontWeight: 500,
    fontStyle: "normal",
    fontStretch: "normal",
    lineHeight: "1.3",
    letterSpacing: "normal",
    textAlign: "left",
    color: theme.colours.grey2,
    paddingLeft: 5,
    paddingBottom: 5,
  },
  horizontalSpace: { paddingRight: "10px" },
  horizontalSpaceSearcher: { paddingRight: "10px", minWidth: 260 },
  textItemContainer: { display: "flex", flexDirection: "column" },
}));

interface SliceFiltrosUsuarios {
  totalRegistros: number;
  page: number;
  take: TakeValue;
  searchCriteria: string;
  getOnlyActivos: boolean;
  permissions: string[];
  isLoading: boolean;
}

const useReduxSelector = () =>
  useSelector<any, SliceFiltrosUsuarios>((state) => ({
    totalRegistros: state.usuariosReducer.totalRegistros,

    page: state.filtrosUsuariosReducer.page,
    take: state.filtrosUsuariosReducer.take,
    searchCriteria: state.filtrosUsuariosReducer.searchCriteria,
    getOnlyActivos: state.filtrosUsuariosReducer.getOnlyActivos,
    permissions: state.authenticatedViewReducer.tokenPermissions,
    isLoading: state.usuariosReducer.isLoading,
  }));

//const messageLoading = "Cargando su consulta previa";

const Filtros: React.FC = () => {
  const {
    take,
    searchCriteria,
    page,
    totalRegistros,
    getOnlyActivos,
    permissions,
    isLoading,
  } = useReduxSelector();

  const dispatch = useDispatch();

  const handleChange = <T,>(
    event: { target: { value: T } },
    action: (value: T) => any
  ) => {
    dispatch(setPage(0));
    dispatch(action(event.target.value));
  };

  const handleChangeGetOnlyActivos = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    dispatch(setPage(0));
    dispatch(setGetOnlyActivos(event.target.checked));
  };

  const handleChangePage = (value: number) => {
    dispatch(setPage(value));
  };

  const canHandleActivo = permissions.includes(permissionHandleUserActivo);

  const paginationOptionsStr = React.useMemo(
    () =>
      paginationOptions.map((option) => ({
        label: String(option.label),
        value: option.value,
      })),
    []
  );

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.filters}>
        <div className={classes.textItemContainer}>
          <Typography variant="h3" className={classes.label}>
            BUSQUEDA
          </Typography>
          <div className={classes.horizontalSpaceSearcher}>
            <Searcher
              filter={searchCriteria}
              placeholder="Nombre o Email"
              onChange={(event) => handleChange(event, selectSearchCriteria)}
              onClear={() =>
                handleChange({ target: { value: "" } }, selectSearchCriteria)
              }
            />
          </div>
        </div>

        {canHandleActivo && (
          <div className={classes.textItemContainer}>
            <Typography
              variant="h3"
              className={classes.label}
              style={{
                paddingBottom: 0,
                marginLeft: 6,
              }}
            >
              SÓLO ACTIVOS
            </Typography>
            <div>
              <Switch
                checked={getOnlyActivos}
                onChange={handleChangeGetOnlyActivos}
              />
            </div>
          </div>
        )}
      </div>

      {!isLoading && (
        <Pagination<TakeValue>
          rowsPerPage={take}
          onChangeRowsPerPage={(value) =>
            handleChange({ target: { value } }, setTake)
          }
          page={page}
          onChangePage={handleChangePage}
          totalRegistros={totalRegistros}
          options={paginationOptionsStr as OptionKV<TakeValue>[]}
        />
      )}
    </div>
  );
};

export default Filtros;
